import { Component, OnInit } from '@angular/core';
import { ErrorService } from 'src/app/services/error.service';
import { ErrorTypes } from 'src/app/enums/errorTypes.enum';
import { TranslateService } from '@ngx-translate/core';
import { ErrorMessage } from 'src/app/models/errorMessage.model';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit {
  showError: ErrorTypes;
  extraMessage: string;

  get errorText(): string {
    const translatedText = this.translateService.instant(this.showError.toString());
    if (translatedText === this.showError.toString()) {
      return this.translateService.instant(ErrorTypes.Generic.toString());
    }
    return translatedText;
  }

  constructor(
    private errorService: ErrorService,
    private translateService: TranslateService
  ) {}

  ngOnInit() {
    this.errorService.errorMessage$.subscribe((errorMessage: ErrorMessage) => {
      this.showError = errorMessage.errorType;
      this.extraMessage = errorMessage.message;
    });
  }
}
